import { atom } from 'recoil';

export const setHelper = atom({
    key: 'setHelper', // unique ID (with respect to other atoms/selectors)
    default: [] // default value (aka initial value)
});  